import { handleActions } from 'redux-actions';
import { types, branchStatus } from '../constants';

import { buttonNames } from '../constants';

const INITIAL_STATE = {
  allBranches: {
    items: [],
    itemsCopy: [],
    isLoading: false,
    errorMessage: '',
    searchTerm: ''
  },
  currentBranchesRecord: buttonNames.DASHBOARD
};

const startLoadBranches = (state) => {
  return {
    ...state,
    allBranches: {
      ...state.allBranches,
      isLoading: true
    }
  };
};

const loadAllBranchesSuccess = (state, { branches }) => {
  const activeBranches = branches.filter(
    (b) => b.status === branchStatus.ACTIVE
  );
  return {
    ...state,
    allBranches: {
      ...state.allBranches,
      items: activeBranches,
      itemsCopy: activeBranches
    }
  };
};

const loadAllBranchesFailure = (state, { errorMessage }) => {
  return {
    ...state,
    allBranches: {
      ...state.allBranches,
      errorMessage
    }
  };
};

const loadAllBranchesFinished = (state) => {
  return {
    ...state,
    allBranches: {
      ...state.allBranches,
      isLoading: false
    }
  };
};

const changeSearchTermAllBranch = (state, { searchTerm }) => {
  let branches = state.allBranches.itemsCopy;
  let filteredBranch = branches.filter(
    (c) =>
      (c.name && c.name.toLowerCase().includes(searchTerm)) ||
      (c.email && c.email.toLowerCase().includes(searchTerm)) ||
      (c.contactPerson && c.contactPerson.toLowerCase().includes(searchTerm))
  );
  if (searchTerm === '') {
    filteredBranch = state.allBranches.itemsCopy;
  }

  return {
    ...state,
    allBranches: {
      ...state.allBranches,
      searchTerm,
      items: filteredBranch
    }
  };
};

const submitBranchesuccess = (state, { submittedBranch }) => {
  let branches = [...state.allBranches.items];
  let updatedBranchIndex = branches.findIndex(
    (e) => e.id === submittedBranch.id
  );

  if (updatedBranchIndex !== -1) {
    branches[updatedBranchIndex] = submittedBranch;
  }
  //Means newly created
  else {
    branches = [...branches, submittedBranch];
  }

  return {
    ...state,
    allBranches: {
      ...state.allBranches,
      items: branches,
      itemsCopy: branches
    }
  };
};

const setCurrentBranchesRecord = (state, { recordType }) => {
  return {
    ...state,
    currentBranchesRecord: recordType
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.START_GET_ALL_BRANCH]: startLoadBranches,
    [types.GET_ALL_BRANCH_SUCCESS]: loadAllBranchesSuccess,
    [types.GET_ALL_BRANCH_FAILURE]: loadAllBranchesFailure,
    [types.GET_ALL_BRANCH_FINISH]: loadAllBranchesFinished,

    [types.CHANGE_SEARCH_TERM_ALL_BRANCH]: changeSearchTermAllBranch,

    [types.SUBMIT_BRANCH_SUCCESS]: submitBranchesuccess,

    [types.SET_CURRENT_BRANCHES_RECORD]: setCurrentBranchesRecord
  },
  INITIAL_STATE
);
